var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoutingO(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 6,
    fill: "#ECD0EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9999 29H23.9999C23.4479 29 22.9999 28.552 22.9999 28C22.9999 27.448 23.4479 27 23.9999 27H26.9999C27.5519 27 27.9999 27.448 27.9999 28C27.9999 28.552 27.5519 29 26.9999 29ZM22.9999 32C22.9999 31.448 23.4479 31 23.9999 31H29.9999C30.5529 31 30.9999 31.448 30.9999 32C30.9999 32.552 30.5529 33 29.9999 33H23.9999C23.4479 33 22.9999 32.552 22.9999 32ZM32.4442 35H21.5552C21.2492 35 21.0002 34.776 21.0002 34.5V19.5C21.0002 19.224 21.2492 19 21.5552 19H27.0002V22.15C27.0002 23.722 28.2172 25 29.7142 25H33.0002V34.5C33.0002 34.776 32.7512 35 32.4442 35ZM29.0002 19.978L31.7422 23H29.7142C29.3202 23 29.0002 22.619 29.0002 22.15V19.978ZM34.7402 23.328L29.2962 17.328C29.1062 17.119 28.8382 17 28.5552 17H21.5552C20.1462 17 19.0002 18.122 19.0002 19.5V34.5C19.0002 35.878 20.1462 37 21.5552 37H32.4442C33.8532 37 35.0002 35.878 35.0002 34.5V24C35.0002 23.751 34.9072 23.512 34.7402 23.328Z",
    fill: "#661C69"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoutingO);
export default __webpack_public_path__ + "static/media/RoutingO.ec190f91fcac33560bcbf758881bbf54.svg";
export { ForwardRef as ReactComponent };